/**
 * © 2024 Tandem Diabetes Care, Inc. All rights reserved.
 * Confidential Information of Tandem Diabetes Care, Inc.
 * Internal Use Only
 */

import { type FC, type PropsWithChildren, useEffect, useState } from 'react';
import { preLoadSegment } from '../utils/segment';

const PreloadAnalytics: FC<PropsWithChildren> = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!loaded) {
      preLoadSegment();
      setLoaded(true);
    }
  }, [loaded]);

  return <>{loaded && children}</>;
};

export default PreloadAnalytics;
